import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

/**
 * TopicLinks — compact contextual internal-linking block.
 * Renders a row of pill links to pages covering topics mentioned on the
 * current page, keeping visitors moving through the site (topic-cluster
 * interlinking) instead of bouncing.
 */
export default function TopicLinks({ heading = 'Keep exploring', intro, links = [] }) {
  if (!links.length) return null;
  return (
    <section className="py-12 bg-slate-50 border-t border-slate-100">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-2xl lg:text-3xl font-light text-slate-800 mb-2">
            {heading.split(' ')[0]} <span className="font-serif italic text-amber-700">{heading.split(' ').slice(1).join(' ')}</span>
          </h2>
          {intro && <p className="text-slate-600 mb-6">{intro}</p>}
          {!intro && <div className="mb-6" />}
          <div className="flex flex-wrap justify-center gap-3">
            {links.map((l) => (
              <a
                key={l.href + l.label}
                href={l.href}
                className="inline-flex items-center gap-1.5 bg-white border border-slate-200 hover:border-amber-300 hover:shadow-md text-slate-700 hover:text-amber-800 px-5 py-2.5 rounded-full text-sm font-medium transition-all"
              >
                {l.label}
                <ArrowRight className="w-3.5 h-3.5" />
              </a>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
